import { LandscapeTypes, LandscapeState, SET_LANDSKAPE } from "../types/landscape";
import { checkLandScape } from "../lib/support";

const initialState: LandscapeState = {
  isLandscape: checkLandScape()
}

export default ( 
  state = initialState,
  action: LandscapeTypes
  ): LandscapeState => {
    switch(action.type) {
      case SET_LANDSKAPE: 
        return {
          ...state,
          isLandscape: action.payload
        }
        default:
          return state
    }
}